<template>
  <div class="weui-cell" style="width: 80%; align-items: flex-start; -webkit-box-align: flex-start;">
    <div class="weui-cell__bd">
      <el-form :model="formdata" label-width="120px" style="margin-top: 50px">
        <el-form-item label="公众号二维码">
          <div style="margin-left: 20px;">
            <el-upload 
              class="addicon addicon-qrcode"
              accept="image/jpeg,image/png"
              :limit="1"
              :data="uploaddata"
              :action="uploadurl"
              :on-error="handleError"
              :on-success="handleSuccess"
              :before-upload="beforeUpload">
              <div v-if="formdata.pub_qr" class="avatar-uploader-icon" style="border-color: #ebebeb;"><img :src="formdata.pub_qr" /></div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="noticeP">上传成功后，小程序名片处将显示该公众号添加入口，便于用户关注</p>
            <el-button type="primary" size="small" class="mt-20 w80" @click="onSave">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="weui-cell__ft">
      <img src="@/assets/imgs/small.png" width="375" />
    </div>    
  </div>
</template>

<script>
import api from "@/api.js";
export default {
  name: 'analyticsOfficialQrcode',
  data() {
    return {
      uploadurl: api.uploadTokenImg,
      uploaddata: {token: sessionStorage.getItem("token")},
      formdata: {
        pub_qr: ''
      }
    }
  },
  mounted() {
    this.axios
      .post(api.getPubQr, {})
      .then(response => {
        if (response.data.code == 0) {
          this.formdata.pub_qr = response.data.pub_qr;
        } 
      })
      .catch(() => {}); 
  },
  methods: {
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      let status = true;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或者PNG 格式!");
        status = false
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        status = false
      }
      if(status){
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      }
      return isJPG && isLt2M;
    },
    handleSuccess(res, file) {
      if (res.code === 0) {
        this.formdata.pub_qr = res.path;
      } else {
        this.$message.error(res.msg);
      }
      this.loadingStatus.close();
    },
    handleError(err, file) {
      this.$message({
        type: "error",
        message: "上传失败"
      });
    },
    onSave() {
      if (!this.formdata.pub_qr) {
        this.$message.error('请上传图片');
        return 
      }
      this.axios
        .post(api.setPubQr, {pub_qr: this.formdata.pub_qr})
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '设置成功！',
            });
          } 
        })
        .catch(() => {});      
    }
  }
}
</script>

